var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"high-res-clipboard-images"},[_c('div',_vm._l((_vm.images),function(src){return _c('img',{attrs:{"src":src},on:{"load":function($event){return _vm.loaded(src)}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }